import { useState } from 'react';

export const CodeApiForm = () => {
  const [pValue] = useState(20);
  const [sValue] = useState(12);

  return (
    <div>
      <code>{"import React, { useState, useEffect } from 'react';"}</code>
      <br />
      <code>{"import axios from 'axios';"}</code>
      <br />
      <br />
      <code>{'const NewTaskForm = () => {'}</code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {"const [title, setTitle] = useState('');"}{' '}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'const [loading, setLoading] = useState(false);'}{' '}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'const [error, setError] = useState(null);'}{' '}
      </code>
      <br />
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'const handleSubmit = async (e) => {'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>
        {'try {'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {"const response = await axios.post('https://api.example.com/tasks', { title });"}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {"console.log('Task created:', response.data);"}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {"setTitle('');"}
      </code>{' '}<span
        style={{
          color: '#999',
          fontSize: `${sValue}px`
        }}
      >
        // Clear the input field after successful creation
      </span>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>
        {'} catch (error) {'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {"setError('Failed to create task');"}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>
        {'} finally {'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'setLoading(false);'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>
        {'}'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>{'};'}</code>
      <br />
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>{'return ('}</code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>{'<form onSubmit={handleSubmit}>'}</code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'<input'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {'type="text"'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {'value={title}'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {'onChange={(e) => setTitle(e.target.value)}'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {'placeholder="Task title"'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'/>'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'<button type="submit" disabled={loading}>'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {"{loading ? 'Creating...' : 'Create Task'}"}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'</button>'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'{error && <p>{error}</p>}'}
      </code>
      <br />

      <code style={{ paddingLeft: `${pValue + pValue}px` }}>{'</form>'}</code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>{');'}</code>
      <br />
      <code>{'};'}</code>
      <br />
      <br />
      <code>{'export default NewTaskForm;'}</code>
    </div>
  );
};
